export default function ({ $gtm }) {
  const tags = process.env.gtmId?.trim();
  if (process.client && tags) {
    function loadGTM() {
      tags.split(',').forEach((tag) => $gtm.init(tag))

      window.removeEventListener('scroll', loadGTM);
      window.removeEventListener('mousemove', loadGTM);
      window.removeEventListener('touchstart', loadGTM);
    }

    window.addEventListener('scroll', loadGTM, { once: true, passive: true });
    window.addEventListener('mousemove', loadGTM, { once: true, passive: true });
    window.addEventListener('touchstart', loadGTM, { once: true, passive: true });
  }
}
